import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// More comprehensive error handling
const originalError = console.error;
console.error = function(...args) {
  // Check for different ResizeObserver error patterns
  const errorPatterns = [
    'ResizeObserver loop', 
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications'
  ];
  
  const firstArg = args[0];
  // Check if first argument is a string that matches any pattern
  if (typeof firstArg === 'string' && 
      errorPatterns.some(pattern => firstArg.includes(pattern))) {
    return;
  }
  
  // Check if it's an error object with a message property
  if (firstArg instanceof Error && 
      errorPatterns.some(pattern => firstArg.message?.includes(pattern))) {
    return;
  }
  
  originalError.apply(console, args);
};

// Also catch window-level errors
window.addEventListener('error', (event) => {
  if (event.message && 
      event.message.includes('ResizeObserver loop')) {
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();




// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const originalError = console.error;

// console.error = function(msg) {
//   if (msg && typeof msg === 'string' && msg.includes('ResizeObserver loop')) {
//     return;
//   }
//   originalError.apply(console, arguments);
// };


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
